import VueTypes from 'vue-types'

export default {
  props: {
    type: {
      type: String,
      default: 'button'
    },
    disabled: Boolean,
    size: VueTypes.oneOf(['medium', 'small', 'big']).def('medium'),
    mode: VueTypes.oneOf([
      'modern'
    ]).def('modern'),
    loading: Boolean,
    textUppercase: Boolean,
    noHover: Boolean,
    shade: Boolean,
    fullWidth: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    spinnerTheme () {
      return this.pickClass({
        light: this.mode === 'normal',
        purple: this.mode === 'transparent-normal',
        red: this.mode === 'transparent-red',
        green: this.mode === 'transparent-green',
        default: 'normal'
      })
    }
  },
  methods: {}
}
